import React from 'react';
import { Modal } from 'react-bootstrap'

export default function HardwareImgModal({
  pageLanguage,
  modals,
  modalHandleClose,
  t,
  rodsListHardware
}) {
 
  return (
   <Modal
   dialogClassName={`learnMore_modal mediumSizeModal ${
     pageLanguage === "fa" ? "font_farsi" : "font_en"
   }`}
   show={modals["hardwareCollections"] === undefined ? false : modals["hardwareCollections"]}
   onHide={() => modalHandleClose("hardwareCollections")}
 >
   <Modal.Header closeButton></Modal.Header>
   <Modal.Body>
     <div className="hardwareBoxModalImg">
        {rodsListHardware}
     </div>

     <br />
     <div className="text_center">
       <button className="btn btn-new-dark" onClick={() => modalHandleClose("hardwareCollections")}>
         {t("CONTINUE")}
       </button>
     </div>
   </Modal.Body>
 </Modal>
  )
}
